import { Button, Grid, Tooltip } from '@mui/material';
import { GridButtonWithTooltipProps } from './types';

const GridButtonWithTooltip = (props: GridButtonWithTooltipProps) => {
  const { buttonText, className, disabled, icon = null, onClick, tooltipText } = props;
  return (
    <Grid item>
      <div>
        <Tooltip arrow title={tooltipText}>
          <span>
            <Button className={className} disabled={disabled} onClick={onClick} startIcon={icon} variant="outlined">
              {buttonText}
            </Button>
          </span>
        </Tooltip>
      </div>
    </Grid>
  );
};

export default GridButtonWithTooltip;
